import { TaxLabels } from '@makemydeal/dr-platform-types';
import type { CustomizablePdfPayload, PdfVehicle } from '@makemydeal/dr-platform-types';

import type { PoTaxBreakdownField } from '../types/proposalMapper';

export const SCI_PROPOSAL_APPLICATION_NAME: CustomizablePdfPayload['applicationName'] = 'Sales View';

export const FUEL_SAVINGS_BAGGAGE_NAME = 'deal360.fuelSavings';

export const CARS_ACT_DISCLOSURE_STATES: Partial<Record<string, boolean>> = {
    CA: true
};

export const VEHICLE_CONDITIONS: PdfVehicle['condition'][] = ['new', 'used', 'certified'];

export const TAX_BREAKDOWN_ORDER: { key: string; label: string }[] = [
    { key: 'City', label: TaxLabels.cityTax },
    { key: 'County', label: TaxLabels.countyTax },
    { key: 'Other', label: TaxLabels.localTax },
    { key: 'State', label: TaxLabels.stateTax }
];

export const PO_TAX_BREAKDOWN_FIELDS: PoTaxBreakdownField[] = [
    { key: 'City', amount: 'cityTax', rate: 'cityTaxRate' },
    { key: 'County', amount: 'countyTax', rate: 'countyTaxRate' },
    { key: 'Other', amount: 'localTax', rate: 'localTaxRate' },
    { key: 'State', amount: 'stateTax', rate: 'stateTaxRate' }
];

export const TRADE_AMOUNT_OWED_LABEL = 'Amount Owed On Trade-In';

export const TRADE_SOURCE = {
    ICO: 'ICO',
    SUBARU_GTP: 'SUBARUGTP'
} as const;

export const TRADE_SOURCE_LABELS: Partial<Record<string, string>> = {
    [TRADE_SOURCE.ICO]: 'KBB Instant Cash Offer',
    [TRADE_SOURCE.SUBARU_GTP]: 'Subaru Guaranteed Trade-in Value'
};

export const DEFAULT_TRADE_SOURCE_LABEL = 'Trade-In Value';

export const BALLOON_DEAL_TYPE = 'Balloon';

export const ACQUISITION_FEE_TYPE_ID = 1050;

export const ONE_PAY_LEASE_PAYMENT_FREQUENCY = 'OneTime';

export const BALLOON_TERM_MINUS_ONE = 'term-1';

export const FEE_CATEGORY = {
    GOVERNMENT: 'Government',
    DEALER: 'dealer',
    LENDER: 'lender'
} as const;

export const ADDITIONAL_TAX_CLASS = 'additional';

export const MONEY_FACTOR_RATE_TYPE = 'MoneyFactor';

export const FLEX_BUY_FIRST_SCHEDULE_INDEX = 0;

export const FLEX_BUY_SECOND_SCHEDULE_INDEX = 1;

export const LEASE_TAX_LABELS = {
    CAPITALIZED: 'Taxes - Capitalized',
    DUE_UPFRONT: 'Taxes - Due Upfront'
} as const;

export const DUE_AT_SIGNING_LABELS = {
    NET_DOWN_PAYMENT: 'Net Down Payment',
    FIRST_MONTH_PAYMENT: 'First Month Payment'
} as const;

export const EMPTY_FUEL_SAVINGS = {
    yearlySavings: 0,
    monthlySavings: 0,
    threeYearSavings: 0
};
